import { render, staticRenderFns } from "./TutorialsDialog.vue?vue&type=template&id=061ccb24"
import script from "./TutorialsDialog.vue?vue&type=script&lang=js"
export * from "./TutorialsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports